import { merge } from 'lodash/fp';

import defaultTheme from '@ihme/common/theme/default';

export default merge(defaultTheme, {
    // add theme overrides here
    textColor: {
        surface: '#4D4D4D', // background surface of components (e.g. Card, Menu, Header, Label, Input, Dropdown Option)
    },

    typography: {
        fontFamily: {
            serif: '"Helvetica", sans-serif',
            sansSerif: '"Helvetica", sans-serif',
        },
        fontSize: {
            small: 14,
            base: 16,
            h1: 32,
        },
        lineHeight: {
            base: 1.5,
            h1: 1,
        },
        fontWeight: {
            light: 200,
            base: 400,
            bold: 600,
        },
    },

    borderRadius: {
        base: 4,
    },

    palette: {
        // primary: '#f2f2f2',
        primarySelected: '#0094C9',
        primaryHover: 'rgba(22, 25, 28, 0.05)',
        // primaryActive: '#E1E1E1',

        primaryText: '#222222',
        primaryTextHover: '#ffffff',
        primaryTextDisabled: '#979797',

        // primaryButton: '#d5982a',
        // primaryButtonHover: '#c1870b',
        // primaryButtonPressed: '#b2801d',

        // highlightedText: '#F3D9B5',
    },
});
